<div class="title-cmp">
  <div class="title navbar-fixed-top">
    <div class="header-panel">
      <div class="header-title" [ngClass]="isTerritoryUser ? '' : 'ntau-search' ">
        <div class="back-arrow" *ngIf="enableBackArrow" (click)="navigateTo()"><img src="assets/images/left-arrow-light.svg" alt="back" /></div>
        <div class="logo"><img src="assets/images/EcolabLogo.svg" alt="Ecolab Title" /></div>
      </div>
      <div class="header-search" [ngClass]="isTerritoryUser ? '' : 'ntau-search' ">
        <div *ngIf="isTerritoryUser then territoryUserBlock; else nonTerritoryUserBlock"></div>
        <ng-template #territoryUserBlock>
          <div *ngIf="isMultipleTerritoryUser then multipleTerritoriesUserBlock; else singleTerritoryUserBlock"></div>
          <ng-template #multipleTerritoriesUserBlock>
            <div class="search" *ngIf="isMultipleTerritoryUser">
              <app-type-ahead [labelForSearchType]="mtauLabelOptions" [listOfSearchItems]="mtauOptions" [maxOptionsCount]="1000" [defaultItem]="mtauSelectedOption"
                              (selectedItem)="onTerritorySelectionChange($event)"></app-type-ahead>
            </div>
          </ng-template>
          <ng-template #singleTerritoryUserBlock>
          <span class="non-searchable" [translate]="'ATHENA_WEB_UI.ORDERS.TITLE.TERRITORY_NO_VALUE'"
                [translateParams]="{territoryId: userService.currentUser.territories[0].territoryId}">
          </span>
          </ng-template>
        </ng-template>
        <ng-template #nonTerritoryUserBlock>
          <app-search [dropdownItems]="ntauSearchOptions" [currentSearchItem]="ntauSearchOptions[0]"
                      [currentInnerSearchItem]="ntauSelectedSalesOrg || ntauSearchOptions[0].innerSearch[0]"
                      (searchContext)="userSearchContext($event)"></app-search>
        </ng-template>
      </div>
      <div class="preferences">
        <div class="pref-icon" (click)="toggleSideNav()"><img src="assets/images/settingsIcon.png" alt="preferences" /></div>
      </div>
      <div class="preferences_1">
        <span alt="Help" title="Click me for Help" class="link" (click)="openDialog()">?</span>
      </div>
    </div>
  </div>
  <div class="center-content">
    <div class="align-content" *ngIf="startTime && endTime">
      <p>Due to scheduled SAP maintenance from {{startTime}} CST to {{endTime}} CST' the Order Tracking details may be delayed / unavailable during maintenance</p>
    </div>
    <mat-sidenav-container class="example-container">
      <mat-sidenav  #settingsSideNav mode="over" [opened]="false" [position]="'end'">
        <div class="drawer-container">
          <div class="header">
            <span class="title" translate="ATHENA_WEB_UI.ORDERS.TITLE.CONTACT"></span>
            <span class="gray-label padding-rt-12" (click)="reset()" translate="ATHENA_WEB_UI.BUTTONS_TEXT.RESET"></span>
          </div>
          <div class="content">
            <app-contact-preference [getAction]="actions.asObservable()"></app-contact-preference>
          </div>
          <div class="footer">
            <button mat-stroked-button color="primary" class="cancel" (click)="close()">{{'ATHENA_WEB_UI.BUTTONS_TEXT.CLOSE' | translate}}</button>
            <button mat-raised-button color="primary" (click)="save()">{{'ATHENA_WEB_UI.BUTTONS_TEXT.SAVE' | translate}}</button>
          </div>
        </div>
      </mat-sidenav>
      <mat-sidenav-content>
        <router-outlet></router-outlet>
      </mat-sidenav-content>
    </mat-sidenav-container>
  </div>
</div>
